import { useState, useEffect } from 'react';
import { useScootQuery, ScootFilters } from './useScootQuery';

export function useScootSearch(searchQuery: string, filters?: ScootFilters) {
  const [debouncedQuery, setDebouncedQuery] = useState(searchQuery);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedQuery(searchQuery);
    }, 300);

    return () => clearTimeout(timer);
  }, [searchQuery]);

  return useScootQuery(debouncedQuery, filters);
}
